import { AttachDetachDetails } from './attach-detach-details';
export class AttachDetachStepperModel {

  public static readonly STEP_SELECT_ACTION = 0;
  public static readonly STEP_DETACH_TRUCK = 1;
  public static readonly STEP_DETACH_TRUCK_AND_TRAILER = 2;
  public static readonly STEP_DETACH_TRAILER = 3;
  public static readonly STEP_ATTACH_TRUCK = 4;
  public static readonly STEP_ATTACH_TRAILER = 5;
  public static readonly STEP_SELECT_TRAILER_SWAP_TARGET = 6;
  public static readonly STEP_TRAILER_SWAP_SOURCE_DETAILS = 7;
  public static readonly STEP_DETACH_TRAILER_SEMI_TRAILER_TRUCK = 8;

  currentComponentIndex = 0;
  stepCompleted: () => boolean;
  getPreviousStepIndex: () => number;
  getNextStepIndex: () => number;
  beforeNextStep: () => boolean;
  /** defines the last steps to enable the finish button  */
  lastSteps: number[] = [];

  /** the orginal details object, do not change this! */
  private details: AttachDetachDetails;

  /** a copy of the details to represent the current state of the stepper */
  workingData: AttachDetachDetails;

  /** create a working copy of supplied data */
  public setDetails(details: AttachDetachDetails) {
    this.details = details;
    this.createWorkingCopy();
  }

  private createWorkingCopy() {
    this.workingData = new AttachDetachDetails();
    this.workingData.action = this.details.action;
    this.workingData.carrier = this.details.carrier;
    this.workingData.driver = this.details.driver;
    this.workingData.numberPlate = this.details.numberPlate;
    this.workingData.cargo = this.details.cargo;
    this.workingData.orderReference = this.details.orderReference;
    this.workingData.swapTrailerNumber = this.details.swapTrailerNumber;
    this.workingData.trailerNumberPlate = this.details.trailerNumberPlate;
    this.workingData.trailerIdentifier = this.details.trailerIdentifier;
    this.workingData.transportId = this.details.transportId;
    this.workingData.transportScope = this.details.transportScope;
    this.workingData.targetTransportScope = this.details.targetTransportScope;
    this.workingData.truckId = this.details.truckId;
    this.workingData.identifier = this.details.identifier;
    this.workingData.warningDictionaryKey = this.details.warningDictionaryKey;
    this.workingData.confirmEnabled = this.details.confirmEnabled;
    this.workingData.trailerSwapTargetId = this.details.trailerSwapTargetId;
    this.workingData.targetStationId = this.details.targetStationId;
  }

  public resetDetails() {
    this.createWorkingCopy();
  }
}
